import { useEffect, useMemo, useState } from 'react';
import { ApiService, FundMeasurementDateName, MeasurementDateName } from 'api';

const useRetrieveDatesForFirm = (firmId: number | null, initialMeasurementDate: FundMeasurementDateName | null) => {
  const [measurementDateNames, setMeasurementDateNames] = useState<Array<FundMeasurementDateName>>([]);
  const [selectedFundMeasurementDate, setSelectedFundMeasurementDate] = useState<FundMeasurementDateName | null>(null);

  useEffect(() => {
    if (initialMeasurementDate) {
      setSelectedFundMeasurementDate(initialMeasurementDate);
    }
  }, [initialMeasurementDate]);

  useEffect(() => {
    if (firmId) {
      ApiService.apiMeasurementDatesAllFundsByFirmRead(firmId.toString()).then(response => {
        setMeasurementDateNames(response);
      });
    }
  }, [firmId]);

  const fundMeasurementDates = useMemo<FundMeasurementDateName[]>(
    () => measurementDateNames.filter(measurementDate => measurementDate.fmd_id) ?? [],
    [measurementDateNames]
  );

  const uniqueFundMeasurementDatesByDate = useMemo<FundMeasurementDateName[]>(() => {
    const uniqueDates = new Set(fundMeasurementDates.map(date => date.date));
    return Array.from(uniqueDates)
      .map(date => fundMeasurementDates.find(d => d.date === date) ?? null)
      .filter(Boolean) as MeasurementDateName[];
  }, [fundMeasurementDates]);

  return {
    uniqueFundMeasurementDatesByDate,
    fundMeasurementDates,
    setSelectedFundMeasurementDate,
    selectedFundMeasurementDate,
  };
};

export default useRetrieveDatesForFirm;
